import { DropdownSearch, Dropdown, GroupedExpandableList } from 'component-library';

import { useTranslation } from 'react-i18next';

import { otherLoadCarriersName } from './otherLoadCarriersName';

export const OtherLoadCarrierPicker = ({
  onChange,
  containerType,
  errorMessage,
}: {
  onChange: (type: string, name: string) => void;
  containerType: string | undefined;
  errorMessage?: string;
}) => {
  const { t } = useTranslation();

  const handleContainerNameChange = (value: string) => {
    const containerName = otherLoadCarriersName(t).find((c) => c.value === value)?.label || '';

    return containerName;
  };

  return (
    <Dropdown
      loading={false}
      error={!!errorMessage}
      errorMessage={errorMessage}
      items={otherLoadCarriersName(t)}
      selectedValues={containerType ? [containerType] : []}
      onChange={(value) => {
        onChange(value[0], handleContainerNameChange(value[0]));
      }}
      label={t(
        'rented-containers.add-containers.step1.add-container.modal.container.type-loadcarrier.label',
      )}
      placeholder={t(
        'rented-containers.add-containers.step1.add-container.modal.container.type-loadcarrier.placeholder',
      )}
    >
      <DropdownSearch />
      <GroupedExpandableList />
    </Dropdown>
  );
};
